module.exports = __webpack_public_path__ + "img/hero-screenshot-2.b5e1d7f8.png";